import clsx from 'clsx';

import { UpsellOptions } from '../../types';
import { SearchUpsellProducts } from '../upsellProducts/SearchUpsellProducts';
import { UpsellChipsComponent } from '../upsellProducts/UpsellChipsComponent';

interface ManageMultiConfigComponentProps {
  currentProductId?: string;
  error: boolean;
  addonProduct: UpsellOptions;
  onChange: (addonProduct: UpsellOptions) => void;
}

// Reuses the upsell products search/attach/chip pattern, constrained to a
// single linked addon product rather than a list.
export default function ManageMultiConfigComponent({
  currentProductId,
  error,
  addonProduct,
  onChange
}: ManageMultiConfigComponentProps) {
  const handleSearchUpdate = (updated: UpsellOptions) => {
    const updatedKeys = Object.keys(updated);
    if (updatedKeys.length <= 1) {
      onChange(updated);
      return;
    }

    const existingKeys = Object.keys(addonProduct);
    const newlySelectedKey =
      updatedKeys.find(key => !existingKeys.includes(key)) ??
      updatedKeys[updatedKeys.length - 1];

    onChange({ [newlySelectedKey]: updated[newlySelectedKey] });
  };

  const dynamicClasses = {
    'bg-light-blue': !error,
    'bg-blush': error
  };

  return (
    <div className={clsx(dynamicClasses, 'p-2')}>
      <SearchUpsellProducts
        currentProductId={currentProductId}
        upsellProducts={addonProduct}
        onUpdateUpsells={handleSearchUpdate}
        placeholder="Multi-Config Addon Product"
      />
      <UpsellChipsComponent
        upsellProducts={addonProduct}
        onUpdateUpsells={onChange}
      />
    </div>
  );
}
